if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', class CollectionFilters extends HTMLElement {
    constructor() {
      super();
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.sidebar = this.querySelector('[data-filter-sidebar]');
      this.backdrop = this.querySelector('[data-filter-backdrop]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.filterCheckboxes = this.querySelectorAll('[data-filter-checkbox]');
      this.filterPriceInputs = this.querySelectorAll('[data-filter-price]');
      this.sectionId = this.dataset.section;
      this.debounceTimer = null;
    }

    connectedCallback() {
      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', () => this.toggleFilters());
      }

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.closeFilters());
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.updateCollection());
      }

      this.filterCheckboxes.forEach(function(cb) {
        cb.addEventListener('change', () => {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => this.updateCollection(), 300);
        });
      }.bind(this));

      this.filterPriceInputs.forEach(function(input) {
        input.addEventListener('change', () => {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => this.updateCollection(), 300);
        });
      }.bind(this));
    }

    toggleFilters() {
      if (this.sidebar) {
        var isOpen = this.sidebar.classList.toggle('is-open');
        if (this.backdrop) this.backdrop.classList.toggle('is-open');
        if (this.filterToggle) this.filterToggle.setAttribute('aria-expanded', isOpen);
      }
    }

    closeFilters() {
      if (this.sidebar) {
        this.sidebar.classList.remove('is-open');
        if (this.backdrop) this.backdrop.classList.remove('is-open');
        if (this.filterToggle) this.filterToggle.setAttribute('aria-expanded', 'false');
      }
    }

    buildUrl() {
      var params = new URLSearchParams();

      // Sort
      if (this.sortSelect && this.sortSelect.value) {
        params.set('sort_by', this.sortSelect.value);
      }

      // Checkbox filters
      this.filterCheckboxes.forEach(function(cb) {
        if (cb.checked) {
          params.append(cb.name, cb.value);
        }
      });

      // Price filters
      this.filterPriceInputs.forEach(function(input) {
        if (input.value) {
          params.set(input.name, (parseFloat(input.value) * 100).toString());
        }
      });

      var searchStr = params.toString();
      return window.location.pathname + (searchStr ? '?' + searchStr : '');
    }

    updateCollection() {
      var url = this.buildUrl();

      // Close mobile sidebar after filter selection
      if (this.sidebar && window.innerWidth < 992) {
        this.closeFilters();
      }

      // Show loading state
      var gridWrapper = this.querySelector('.clp-grid-wrapper');
      if (gridWrapper) {
        gridWrapper.style.opacity = '0.5';
        gridWrapper.style.pointerEvents = 'none';
        gridWrapper.style.transition = 'opacity 200ms ease';
      }

      fetch(url)
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Swap product grid
          var newGrid = doc.getElementById('CollectionProductGrid');
          var currentGrid = document.getElementById('CollectionProductGrid');
          if (newGrid && currentGrid) {
            currentGrid.parentElement.innerHTML = newGrid.parentElement.innerHTML;
          }

          // Update toolbar (filter count badge + active filters)
          var newFilters = doc.querySelector('collection-filters');
          if (newFilters) {
            // Update filter toggle count badge
            var newCountBadge = newFilters.querySelector('.clp-filter-toggle__count');
            var currentToggle = document.querySelector('.clp-filter-toggle');
            var currentCountBadge = currentToggle ? currentToggle.querySelector('.clp-filter-toggle__count') : null;
            if (currentToggle) {
              if (newCountBadge) {
                if (currentCountBadge) {
                  currentCountBadge.textContent = newCountBadge.textContent;
                } else {
                  currentToggle.insertAdjacentHTML('beforeend', newCountBadge.outerHTML);
                }
              } else if (currentCountBadge) {
                currentCountBadge.remove();
              }
            }

            // Update active filter tags
            var newActiveTags = newFilters.querySelector('.clp-active-filters');
            var currentActiveTags = document.querySelector('.clp-active-filters');
            if (newActiveTags) {
              if (currentActiveTags) {
                currentActiveTags.outerHTML = newActiveTags.outerHTML;
              } else {
                var toolbar = document.querySelector('.clp-toolbar');
                if (toolbar) {
                  toolbar.insertAdjacentHTML('afterend', newActiveTags.outerHTML);
                }
              }
            } else if (currentActiveTags) {
              currentActiveTags.remove();
            }
          }

          // Re-bind active filter tag click handlers (they use href navigation)
          // No JS needed — they are standard <a> links that trigger page navigation

          // Re-init scroll reveals
          if (typeof window.initScrollReveals === 'function') {
            window.initScrollReveals();
          }

          // Update product count
          var newCount = doc.getElementById('CollectionProductCount');
          var currentCount = document.getElementById('CollectionProductCount');
          if (newCount && currentCount) currentCount.textContent = newCount.textContent;

          // Update URL
          history.replaceState(null, '', url);

          // Scroll to top of grid
          var toolbar = document.querySelector('.clp-toolbar');
          if (toolbar) toolbar.scrollIntoView({ behavior: 'smooth', block: 'start' });

          // Remove loading state
          var gridWrapper = this.querySelector('.clp-grid-wrapper');
          if (gridWrapper) {
            gridWrapper.style.opacity = '';
            gridWrapper.style.pointerEvents = '';
          }
        }.bind(this))
        .catch(function(err) {
          console.error('Filter error:', err);
          if (typeof window.showToast === 'function') window.showToast('Filters could not be applied. Please try again.', 'error');
          // Remove loading state on error too
          var gridWrapper = this.querySelector('.clp-grid-wrapper');
          if (gridWrapper) {
            gridWrapper.style.opacity = '';
            gridWrapper.style.pointerEvents = '';
          }
        });
    }
  });
}
